import OrgAnalyticsCharts from "./OrgAnalyticsCharts";

export default OrgAnalyticsCharts;
